import { Tracabilite } from 'src/app/domain/Tracabilite/tracabilite';

export class InterventionUpdateDTO {
    Code: string;
    Date: Date;
    SamplingDuration: number;
    GeographicAccess: string;
    SamplerPuid: string;
    Sampler3Puid: string;
    ResponsiblePuid: string;
    Tracabilite: Tracabilite;
}
